<template>
  <div>
    <div v-if="info && sortMailFlag(text).length>0">
      <div v-if="sortMailFlag(text).length>=2">
        <div>
        <span>
          <el-tag :type="mails.find(item => item.value === text[sortMailFlag(text)[0]]).type">
            {{ mails.find(item => item.value === text[sortMailFlag(text)[0]]).name }}</el-tag>
          <el-link style="margin-left:5px" @click="handleMail(sortMailFlag(text)[0])"
                   v-html="viewDetailIcon"></el-link>
          <el-tooltip content="折叠" v-if="showToolTip[index]">
            <i class="el-icon-caret-top iconMore" @click="openMore(index)"></i>
          </el-tooltip>
          <el-tooltip content="展开" v-if="!showToolTip[index]">
            <i class="el-icon-caret-bottom iconMore" @click="openMore(index)"></i>
          </el-tooltip>
        </span>
          <div v-for="(con,index1) in sortMailFlag(text)" :key="index1" v-if="showToolTip[index]">
            <br v-if="index1!==0">
            <el-tag v-if="index1!==0" :type="mails.find(item => item.value === text[con]).type">
              {{ mails.find(item => item.value === text[con]).name }}
            </el-tag>
            <el-link v-if="index1!==0" style="margin-left:5px" @click="handleMail(con)"
                     v-html="viewDetailIcon"></el-link>
          </div>
        </div>
      </div>
      <div v-else>
        <el-tag :type="mails.find(item => item.value === Object.values(text)[0]).type">
          {{ mails.find(item => item.value === Object.values(text)[0]).name }}
        </el-tag>
        <el-link style="margin-left:5px" @click="handleMail(sortMailFlag(text)[0])"
                 v-html="viewDetailIcon"></el-link>
      </div>
    </div>
    <div v-else>
      <el-tag v-if="type==='mail'" type="warning" color="#ffffff">未申请</el-tag>
      <el-tag v-else-if="type==='request'" type="warning" color="#ffffff">待审核</el-tag>
    </div>
    <mail-details v-if="showMailInfos" :show-dialog="showMailInfos" :select-detail="MailInfos" @submit="closeShowMail"></mail-details>
    <request-details v-if="showRequestDetail" :show-dialog="showRequestDetail" :select-detail="RequestDetail" @submit="closeShowRequest"></request-details>
  </div>
</template>

<script>
import {getMailPage} from "@/api/dilivery/mail";
import MailDetails from "@/components/mail/MailDetails.vue";
import {viewDetailIcon} from "@/utils/icon";
import RequestDetails from "@/components/material/Request/RequestDetails.vue";
import {getRequestPage} from "@/api/dilivery/material/request";

export default {
  name: "ExFoldMail",
  components: {RequestDetails, MailDetails},
  props: {
    mails:{
      default:() => ([])
    },
    info:{
      default:() => ({})
    },
    index:{
      default:0
    },
    type:{
      default:''
    },
    contractId:{
      default:''
    },
  },
  data() {
    return {
      showToolTip: [],
      showMailInfos: false,
      MailInfos: '',
      viewDetailIcon: viewDetailIcon,
      showRequestDetail:false,
      RequestDetail:{},
    }
  },
  computed:{
    text() {
      if(this.type === 'mail'){
        return this.info
      }else{
        if (!this.info || !Array.isArray(this.info) || this.info.length === 0) return {}
        const text = {}
        this.info.forEach((item, index) => {
          if(item.trackingFlag === -1){
            text[index] = 0
          }else if(item.trackingFlag === 0){
            text[index] = 1
          }else{
            text[index] = 2
          }
        })
        return text
      }
    }
  },
  watch:{
  },
  methods: {
    closeShowRequest(type){
      this.RequestDetail = {}
      this.showRequestDetail = false
      if (type === 'confirm') {
       this.$emit('event','confirm')
      }
    },
    closeShowMail(type) {
      this.MailInfos = ''
      if (type === 'confirm') {
        this.$emit('event','confirm')
      }
      this.showMailInfos = false
    },
    handleMail(key) {
      if (this.type === 'mail') {
        let params = {
          'page.current': 1,
          'page.size': 500,
        }
        let data = {
          "query#id.EQ": key
        }
        getMailPage(params, data).then(res => {
          if (res.code === 200 && res.data.records.length > 0) {
            this.MailInfos = res.data.records[0]
            this.showMailInfos = true
          }
        }).catch(error => {
        })
      } else {
        let params = {
          'page.current': 1,
          'page.size': 500,
        }
        let data = {
          "query#contractId.EQ": this.contractId
        }
        getRequestPage(params, data).then(res => {
          if (res.code === 200 && res.data.records.length > 0) {
            const record = JSON.parse(JSON.stringify(res.data.records[0]))
            const batchIndex = parseInt(key)
            const batchItem = this.info[batchIndex] || {}
            const batchDetails = batchItem.details || []
            record.materialRequestDetailDTOS = batchDetails.map(d => ({
              materialLexiconDTO: { materialName: d.materialName },
              number: d.number,
              specs: d.specs
            }))
            // 使用对应批次的trackingFlag和cancelReason
            record.trackingFlag = batchItem.trackingFlag
            record.rejectionReason = batchItem.cancelReason || ''
            record.status = batchItem.trackingFlag === -1 ? 'DEFEAT' : ''
            this.RequestDetail = record
            this.showRequestDetail = true
          }
        }).catch(error => {
        })
      }
    },
    sortMailFlag(data) {
      const order = this.mails.map(item => item.value);
      return Object.keys(data).sort((a, b) =>
          order.indexOf(data[a]) - order.indexOf(data[b])
      )
    },
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}
.flex-container {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  max-width: 600px; /* 根据需要调整最大宽度 */
  margin: 0 auto; /* 居中整个容器 */
}

.name-right {
  text-align: right; /* 右对齐名称部分 */
  min-width: 100px; /* 最小宽度，防止名称过短时布局错乱 */
  max-width: 200px; /* 最大宽度，防止名称过长时占据过多空间 */
  margin-right: 10px; /* 可选：添加右侧间距 */
}
</style>
